const WORK_STATUS_CODE = {
  OPEN: '0',
  SIGN_OFF: '2',
};

export default WORK_STATUS_CODE;
